// src/components/Hero.js
import React from "react";
import "../styles/hero.css";
import heroImage from "../assets/hero.jpg";

const Hero = () => {
  const scrollToKontakt = () => {
    const el = document.getElementById("kontakt");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
      <div className="hero-overlay" />
      <div className="container hero-content fade-in">
        <div className="hero-badge">
          Dobro došli na mjesto koje stvara sretne trenutke
        </div>
        <h1 className="hero-title">
          Personalizirane <span>poklon kutije i drugi proizvodi</span> za sve prigode.
        </h1>
        <p className="hero-text">
          Ako ste u potrazi za poklonom koji se pamti, na pravom ste mjestu.
          Svaka KBIA poklon kutija ručno je složena s pažnjom, kvalitetnim
          materijalima i puno ljubavi – za vaše kumove, prijatelje i obitelj.
        </p>

        <div className="hero-actions">
          <a
            href="https://shop.kbia.hr/wp/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            TRGOVINA
          </a>
          <button className="btn btn-outline" onClick={scrollToKontakt}>
            Pošalji upit
          </button>
        </div>

        <div className="hero-meta">
          <div>
            <span className="hero-meta-number">2019.</span>
            <span className="hero-meta-label">Godina osnivanja</span>
          </div>
          <div>
            <span className="hero-meta-number">1000+</span>
            <span className="hero-meta-label">izrađenih poklon kutija</span>
          </div>
          <div>
            <span className="hero-meta-number">Sve prigode</span>
            <span className="hero-meta-label">
              vjenčanja, krštenja, rođendani…
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
